export const SPOTLIGHT_TRIGGER_TEST_ID = 'spotlight-trigger';

export const SPOTLIGHT_ACTIONS_RELEASE_DATE = '2024-08-13';
